import axios from 'axios'
import interceptorSetup from './interceptors'

import * as auth from './auth'
import * as user from './user'
import * as account from './account'
import * as order from './order'
import * as uploads from './uploads'
import * as delivery from './delivery'
import * as masterDataUserAdmin from './masterDataUserAdmin'
import * as notifications from './notifications'
import * as report from './report'

if (process.env.VUE_APP_API_TARGET === 'mock') {
  require('../mock-services') // import mock adapter if env is mock
}

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
interceptorSetup()

export {
  auth,
  user,
  account,
  order,
  uploads,
  delivery,
  masterDataUserAdmin,
  notifications,
  report
}
